"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomError = void 0;
const isError_1 = require("./isError");
const isCustomError = function (ex, errorType) {
    return (isError_1.isError(ex) &&
        (errorType === undefined || (ex.code === errorType.code)));
};
exports.isCustomError = isCustomError;
